/**
 * Templates Layout Route
 * Layout route that provides structure for the template gallery + builder pages.
 * Renders an Outlet for child routes (index, new, $templateId).
 *
 * Without this Outlet pattern, /templates/new and /templates/:id would
 * render the parent's component (the gallery) instead of the child route.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';

const TemplatesLayoutComponent = () => {
  return <Outlet />;
};

export const Route = createFileRoute('/_authenticated/templates')({
  component: TemplatesLayoutComponent,
});
